import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SharedModule } from '@shared/shared.module';

import { ViewMerchantComponent } from './components/view-merchant/view-merchant.component';

@NgModule({
  declarations: [ViewMerchantComponent],
  exports: [ViewMerchantComponent],
  imports: [CommonModule, SharedModule],
})
export class EasylotAdminSharedModule {}
